/**
 * 缩略图预览
 * 2018-2-7
 * Bai.Zhiming
 */
"use strict";
angular.module("thumbPreviewModule", []).
directive("thumbPreview", ["$q", "$templateRequest", "$compile", "$timeout", function($q, $templateRequest, $compile, $timeout) {
    return {
        restrict: "A",
        replace: false,
        transclude: false,
        scope: {
            showPreview: "=",
            src: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    templateUrl: "./components/service/editPicture/directive/thumbPreview_tpl.html",
                };
                loadTemplate().then(function() {
                    return getShowPreview2();
                }).then(function() {
                    return loadImage();
                }).then(function() {
                    bindScroll();
                    initWatchers();
                    bindDrag();
                });
            }
            /**
             * [bindDrag description] 绑定拖动事件
             * @return {[type]} [description]
             */
            function bindDrag() {
                $elem.find(".scroll-div").eq(0).draggable({
                    containment: "parent",
                    drag: function() {
                        var left = Number($(this).css("left").replace(/px/, ""));
                        var top = Number($(this).css("top").replace(/px/, ""));
                        var ratio = scope.status.imgWidth < scope.status.imgHeight ? 100 / scope.status.imgHeight : 150 / scope.status.imgWidth;
                        $elem.find(".show_photo_inner").scrollTop(top / ratio);
                        $elem.find(".show_photo_inner").scrollLeft(left / ratio);
                        /*$elem.find(".show_photo_inner").css({
                            top: ratio * scrollTop,
                            left: ratio * scrollLeft
                        });*/
                    }
                });
            }
            /**
             * [initWatchers description] 初始化监听
             * @return {[type]} [description]
             */
            function initWatchers() {
                if (scope.status.watcher1) {
                    scope.status.watcher1();
                    scope.status.watcher1 = null;
                }
                if (scope.status.watcher2) {
                    scope.status.watcher2();
                    scope.status.watcher2 = null;
                }
                scope.status.watcher1 = scope.$watch("showPreview", function(newV, oldV) {
                    if (!newV) return;
                    if (newV === oldV) return;
                    getShowPreview2().then(function() {
                        return loadImage();
                    }).then(function() {
                        bindScroll();
                        initWatchers();
                        bindDrag();
                    });
                });
                scope.status.watcher2 = scope.$watch("src", function(newV, oldV) {
                    if (!newV) return;
                    if (newV === oldV) return;
                    getShowPreview2().then(function() {
                        return loadImage();
                    }).then(function() {
                        bindScroll();
                        initWatchers();
                        bindDrag();
                    });
                });
            }
            /**
             * [bindScroll description] 绑定滚动事件
             * @return {[type]} [description]
             */
            function bindScroll() {
                $elem.find(".show_photo_inner").unbind("scroll").bind("scroll", function() {
                    var scrollTop = $elem.find(".show_photo_inner")[0].scrollTop;
                    var scrollLeft = $elem.find(".show_photo_inner")[0].scrollLeft;
                    var ratio = scope.status.imgWidth < scope.status.imgHeight ? 100 / scope.status.imgHeight : 150 / scope.status.imgWidth;
                    $elem.find(".scroll-div").css({
                        top: ratio * scrollTop,
                        left: ratio * scrollLeft
                    });
                });
            }
            /**
             * [loadImage description] 初始化图片
             * @return {[type]} [description]
             */
            function loadImage() {
                var deffer = $q.defer();
                var img = new Image();
                img.src = scope.src;
                img.onload = function() {
                    var width = scope.status.imgWidth = img.width;
                    var height = scope.status.imgHeight = img.height;
                    $timeout(function() {
                        $elem.find(".preview-img").removeAttr('style');
                        $elem.find(".preview-img").removeAttr('style');
                        if (width > height) {
                            var realHeight = height * (150 / width);
                            $elem.find(".preview-img").css({
                                width: 150,
                                top: (100 - realHeight) / 2
                            });
                            $elem.find(".scroll-div").css({
                                height: realHeight * ($elem.height() / height) > realHeight ? realHeight : realHeight * ($elem.height() / height),
                                width: 150 * ($elem.width() / width),
                                marginTop: (100 - realHeight) / 2,
                                marginBottom: (100 - realHeight) / 2,
                                marginLeft:0,
                                marginRight:0,
                            });
                        } else {
                            var realWidth = width * (100 / height);
                            $elem.find(".preview-img").css({
                                height: 100,
                                left: (150 - realWidth) / 2
                            });
                            $elem.find(".scroll-div").css({
                                width: realWidth * ($elem.width() / width) > realWidth ? realWidth : realWidth * ($elem.width() / width),
                                height: 100 * ($elem.height() / height),
                                marginLeft: (150 - realWidth) / 2,
                                marginRight: (150 - realWidth) / 2,
                                marginTop:0,
                                marginBottom:0,
                            });
                        }
                        deffer.resolve();
                    });
                };
                return deffer.promise;
            }
            /**
             * [loadTemplate description] 加载模板 
             * @return {[type]} [description]
             */
            function loadTemplate() {
                var deffer = $q.defer();
                $templateRequest(scope.status.templateUrl).then(function(html) {
                    var $html = $compile($(html))(scope);
                    $elem.append($html);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [getShowPreview2 description] 获取第二组展示预览图的条件
             * @return {[type]} [description]
             */
            function getShowPreview2() {
                var deffer = $q.defer();
                var img = new Image();
                img.src = scope.src;
                img.onload = function() {
                    var boxWidth = $elem.width();
                    var boxHeight = $elem.height();
                    $timeout(function() {
                        if (img.width > boxWidth || img.height > boxHeight) {
                            scope.status.showPreview2 = true;
                        } else {
                            scope.status.showPreview2 = false;
                        }
                        deffer.resolve();
                    });
                };
                return deffer.promise;
            }
        }
    };
}]);